var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBoomArmUp = function SvgIconBoomArmUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.998 3.25a.5.5 0 0 0-1 0v8.535a3.5 3.5 0 0 0-3 3.465v2c0 .79.262 1.52.704 2.105l.685 1.713c.127.318.33.6.592.82a3.29 3.29 0 0 0 4.45-.189l3.36-3.36a1 1 0 0 0 .958-.26l.707-.708a1 1 0 0 0-1.414-1.414l-.707.707a1 1 0 0 0-.257.974l-3.354 3.354c-.842.842-2.188.9-3.098.132a1.1 1.1 0 0 1-.309-.427l-.07-.178a3.5 3.5 0 0 0 4.754-3.269v-2a3.5 3.5 0 0 0-3.001-3.465zm-3 12a2.5 2.5 0 0 1 5 0v2a2.5 2.5 0 0 1-5 0z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17.66 6.071-.697.698a8.5 8.5 0 0 1 2.186 8.887.5.5 0 1 1-.947-.322 7.5 7.5 0 0 0-1.947-7.858l-.716.716a.5.5 0 0 1-.836-.223l-.78-2.899a.5.5 0 0 1 .616-.614l2.898.779a.5.5 0 0 1 .223.836"
  })));
};
export default SvgIconBoomArmUp;